// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ProgramModel {
    static getAttributeTypeMap() {
        return ProgramModel.attributeTypeMap;
    }
}
ProgramModel.discriminator = undefined;
ProgramModel.additionalProperties = false;
ProgramModel.attributeTypeMap = [
    {
        "name": "tenantId",
        "baseName": "tenantId",
        "type": "number"
    },
    {
        "name": "programId",
        "baseName": "programId",
        "type": "number"
    },
    {
        "name": "programNumber",
        "baseName": "programNumber",
        "type": "number"
    },
    {
        "name": "programTypeCode",
        "baseName": "programTypeCode",
        "type": "string"
    },
    {
        "name": "programTypeId",
        "baseName": "programTypeId",
        "type": "number"
    },
    {
        "name": "programName",
        "baseName": "programName",
        "type": "string"
    },
    {
        "name": "programDesc",
        "baseName": "programDesc",
        "type": "string"
    },
    {
        "name": "programStartDate",
        "baseName": "programStartDate",
        "type": "Date"
    },
    {
        "name": "programEndDate",
        "baseName": "programEndDate",
        "type": "Date"
    },
    {
        "name": "programCreateDate",
        "baseName": "programCreateDate",
        "type": "Date"
    },
];
//# sourceMappingURL=programModel.js.map